<template>
  <div class="home-container">
    <div class="home-header">
      <div class="header-content">
        <div class="logo-section">
          <div class="logo-icon">📱</div>
          <div class="logo-text">
            <h1>千川视频管理</h1>
            <p>专业电商视频处理平台</p>
          </div>
        </div>
        <div class="user-info">
          <div class="user-avatar">👤</div>
          <span class="user-name">电商用户</span>
          <button @click.stop="handleLogout" class="logout-button">
            <span class="logout-icon">🚪</span>
            <span>退出登录</span>
          </button>
        </div>
      </div>
    </div>

    <div class="home-content">
      <div class="welcome-section">
        <h2 class="welcome-title">欢迎使用千川视频管理平台</h2>
        <p class="welcome-subtitle">选择您需要的功能，开始您的视频处理之旅</p>
      </div>

      <div class="feature-grid">

        <div
          v-if="canShowButton('home.uploadVideo')"
          class="feature-card"
          :class="{ 'disabled-feature': !canOpenButton('home.uploadVideo') }"
          @click="handleFeatureCardClick('home.uploadVideo', goToUploadVideo)"
        >
          <div class="card-icon">📹</div>
          <h3 class="card-title">视频上传</h3>
          <p class="card-description">批量上传视频素材，智能分类管理</p>
          <div class="card-features">
            <span class="feature-tag">批量处理</span>
            <span class="feature-tag">智能分类</span>
          </div>
          <button class="card-button" :disabled="!canOpenButton('home.uploadVideo')">
            <span>{{ canOpenButton('home.uploadVideo') ? '上传视频' : '已禁用' }}</span>
            <span class="button-arrow">→</span>
          </button>
        </div>

        <div
          v-if="canShowButton('home.videoTools')"
          class="feature-card"
          :class="{ 'disabled-feature': !canOpenButton('home.videoTools') }"
          @click="handleFeatureCardClick('home.videoTools', goToVideoTools)"
        >
          <div class="card-icon">🧰</div>
          <h3 class="card-title">视频工具</h3>
          <p class="card-description">快速打开本地视频处理工具软件</p>
          <div class="card-features">
            <span class="feature-tag">MD5修改</span>
            <span class="feature-tag">批量处理</span>
          </div>
          <button class="card-button" :disabled="!canOpenButton('home.videoTools')">
            <span>{{ canOpenButton('home.videoTools') ? '打开工具' : '已禁用' }}</span>
            <span class="button-arrow">→</span>
          </button>
        </div>

        <div
          v-if="canShowButton('home.walletManagement')"
          class="feature-card"
          :class="{ 'disabled-feature': !canOpenButton('home.walletManagement') }"
          @click="handleFeatureCardClick('home.walletManagement', goToWalletManagement)"
        >
          <div class="card-icon">💰</div>
          <h3 class="card-title">余额管理</h3>
          <p class="card-description">查看账户转账资金记录与目标账户信息</p>
          <div class="card-features">
            <span class="feature-tag">余额列表</span>
            <span class="feature-tag">资金明细</span>
          </div>
          <button class="card-button" :disabled="!canOpenButton('home.walletManagement')">
            <span>{{ canOpenButton('home.walletManagement') ? '进入管理' : '已禁用' }}</span>
            <span class="button-arrow">→</span>
          </button>
        </div>

        <div
          v-if="canShowButton('home.dataOverview')"
          class="feature-card"
          :class="{ 'disabled-feature': !canOpenButton('home.dataOverview') }"
          @click="handleFeatureCardClick('home.dataOverview', goToDataOverview)"
        >
          <div class="card-icon">📊</div>
          <h3 class="card-title">数据概览</h3>
          <p class="card-description">查看任务投放数据卡片并按指标自定义排序</p>
          <div class="card-features">
            <span class="feature-tag">数据汇总</span>
            <span class="feature-tag">自定义排序</span>
          </div>
          <button class="card-button" :disabled="!canOpenButton('home.dataOverview')">
            <span>{{ canOpenButton('home.dataOverview') ? '打开概览' : '已禁用' }}</span>
            <span class="button-arrow">→</span>
          </button>
        </div>

      </div>
    </div>
    <div v-if="showQrModal" class="wechat-modal-mask" @click.self="closeQrModal">
      <div class="wechat-modal">
        <div class="wechat-modal-header">
          <h3>收款码</h3>
          <button class="wechat-close-button" type="button" @click="closeQrModal">关闭</button>
        </div>
        <div class="wechat-modal-body">
          <img class="wechat-qr-image" :src="wechatQrUrl" alt="收款码" />
          <p class="wechat-link-text">{{ wechatNotifyLink }}</p>
        </div>
      </div>
    </div>

    <div class="background-animation">
      <div class="tech-grid"></div>
      <div class="floating-element element-1"></div>
      <div class="floating-element element-2"></div>
      <div class="floating-element element-3"></div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import API_CONFIG from '@/api/config'

export default {
  name: 'HomePage',
  data() {
    return {
      cardNumber: '',
      remainDays: '0',
      remainAuthorizedCount: '0',
      showQrModal: false,
      buttonPermissions: {}
    }
  },
  created() {
    this.cardNumber = localStorage.getItem('cardNumber') || ''
    this.remainDays = localStorage.getItem('remainDays') || '0'
    this.remainAuthorizedCount = localStorage.getItem('remainAuthorizedCount') || '0'
    this.fetchButtonPermissions()
  },
  computed: {
    wechatNotifyLink() {
      return `http://wxsq.xxdazz.com?card_number=${encodeURIComponent(this.cardNumber || '')}`
    },
    wechatQrUrl() {
      return `https://api.qrserver.com/v1/create-qr-code/?size=260x260&data=${encodeURIComponent(this.wechatNotifyLink)}`
    }
  },
  methods: {
    async fetchButtonPermissions() {
      const cardNumber = this.cardNumber || localStorage.getItem('cardNumber') || ''
      if (!cardNumber) {
        this.buttonPermissions = {}
        return
      }
      try {
        const response = await axios.get(API_CONFIG.getButtonPermissionListUrl(), {
          params: { cardNumber }
        })
        if (response.data && response.data.code === 200) {
          this.buttonPermissions = response.data.data || {}
          localStorage.setItem('buttonPermissions', JSON.stringify(this.buttonPermissions))
          return
        }
      } catch (error) {
        console.error('获取按钮权限失败:', error)
      }
      const localPermissions = localStorage.getItem('buttonPermissions')
      if (localPermissions) {
        try {
          this.buttonPermissions = JSON.parse(localPermissions) || {}
        } catch (e) {
          this.buttonPermissions = {}
        }
      }
    },
    getButtonPermission(buttonKey) {
      const value = this.buttonPermissions?.[buttonKey]
      if (!value) {
        return { visible: true, enabled: true }
      }
      return {
        visible: value.visible !== false,
        enabled: value.enabled !== false
      }
    },
    canShowButton(buttonKey) {
      return this.getButtonPermission(buttonKey).visible
    },
    canOpenButton(buttonKey) {
      return this.getButtonPermission(buttonKey).enabled
    },
    handleFeatureCardClick(buttonKey, handler) {
      if (!this.canOpenButton(buttonKey)) {
        alert('当前卡密暂无此功能权限')
        return
      }
      if (typeof handler === 'function') {
        handler()
      }
    },
    goToAuthorization() {
      console.log('授权按钮被点击')
      console.log('Router实例:', this.$router)
      try {
        this.$router.push('/authorization')
        console.log('跳转到授权页面成功')
      } catch (error) {
        console.error('跳转到授权页面失败:', error)
      }
    },
    goToUploadVideo() {
      console.log('授权按钮被点击')
      console.log('Router实例:', this.$router)
      try {
        const routeData = this.$router.resolve({
          path: '/authorization'
        })
        window.open(routeData.href, '_blank')
        console.log('打开授权页面成功')
      } catch (error) {
        console.error('打开授权页面失败:', error)
      }
    },
    goToVideoTools() {
      console.log('视频工具按钮被点击')
      console.log('Router实例:', this.$router)
      try {
        const routeData = this.$router.resolve({
          path: '/video-tools'
        })
        window.open(routeData.href, '_blank')
        console.log('打开视频工具页面成功')
      } catch (error) {
        console.error('打开视频工具页面失败:', error)
      }
    },
    goToWalletManagement() {
      console.log('余额管理按钮被点击')
      console.log('Router实例:', this.$router)
      try {
        const cardNumber = localStorage.getItem('cardNumber') || ''
        const routeData = this.$router.resolve({
          path: '/wallet-management',
          query: cardNumber ? { cardNumber } : {}
        })
        window.open(routeData.href, '_blank')
        console.log('打开余额管理页面成功')
      } catch (error) {
        console.error('打开余额管理页面失败:', error)
      }
    },
    goToDataOverview() {
      console.log('数据概览按钮被点击')
      console.log('Router实例:', this.$router)
      try {
        const cardNumber = localStorage.getItem('cardNumber') || ''
        const routeData = this.$router.resolve({
          path: '/data-overview',
          query: cardNumber ? { cardNumber } : {}
        })
        window.open(routeData.href, '_blank')
        console.log('打开数据概览页面成功')
      } catch (error) {
        console.error('打开数据概览页面失败:', error)
      }
    },
    openQrModal() {
      this.showQrModal = true
    },
    closeQrModal() {
      this.showQrModal = false
    },
    
    // 退出登录
    handleLogout() {
      // 清除本地存储的认证信息
      localStorage.removeItem('authToken');
      localStorage.removeItem('cardNumber');
      localStorage.removeItem('remainDays');
      localStorage.removeItem('remainAuthorizedCount');
      localStorage.removeItem('buttonPermissions');
      
      // 显示退出成功消息
      alert('退出登录成功');
      
      // 立即跳转到登录页面
      this.$router.push('/');
    }
  }
}
</script>

<style scoped>
.home-container {
  min-height: 100vh;
  background: linear-gradient(135deg, #1e3c72 0%, #2a5298 100%);
  position: relative;
  overflow: hidden;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}.home-header {
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(10px);
  border-bottom: 1px solid rgba(255, 255, 255, 0.2);
  padding: 20px 0;
  position: relative;
  z-index: 10;
}

.header-content {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.logo-section {
  display: flex;
  align-items: center;
}

.logo-icon {
  font-size: 32px;
  margin-right: 15px;
  background: linear-gradient(45deg, #00d4ff, #667eea);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.logo-text h1 {
  color: white;
  font-size: 24px;
  margin: 0 0 5px 0;
  font-weight: 600;
}

.logo-text p {
  color: rgba(255, 255, 255, 0.8);
  font-size: 14px;
  margin: 0;
}

.header-stats {
  display: flex;
  align-items: center;
  gap: 12px;
}

.header-stats .stat-item {
  min-width: 140px;
  text-align: center;
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.25);
  border-radius: 12px;
  padding: 8px 12px;
}

.user-info {
  display: flex;
  align-items: center;
  color: white;
}

.user-avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: linear-gradient(45deg, #667eea, #764ba2);
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 10px;
  font-size: 18px;
}

.user-name {
  font-size: 16px;
  font-weight: 500;
  margin-right: 15px;
}

/* 退出按钮样式 */
.logout-button {
  background: rgba(255, 107, 107, 0.2);
  border: 1px solid rgba(255, 107, 107, 0.4);
  border-radius: 20px;
  padding: 8px 16px;
  color: #ff6b6b;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  gap: 6px;
}

.logout-button:hover {
  background: rgba(255, 107, 107, 0.3);
  transform: translateX(3px);
  color: #ff5252;
}

.logout-icon {
  font-size: 14px;
}

.home-content {
  max-width: 1400px;
  margin: 0 auto;
  padding: 28px 16px 20px;
  position: relative;
  z-index: 10;
}

.welcome-section {
  text-align: center;
  margin-bottom: 18px;
}

.welcome-title {
  color: white;
  font-size: 30px;
  font-weight: 700;
  margin: 0 0 15px 0;
  background: linear-gradient(45deg, #00d4ff, #667eea);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.welcome-subtitle {
  color: rgba(255, 255, 255, 0.8);
  font-size: 16px;
  margin: 0;
}

.feature-grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 14px;
  margin-bottom: 12px;
}

.clickable-stat {
  cursor: pointer;
  transition: all 0.3s ease;
}

.clickable-stat:hover {
  transform: translateY(-3px);
}

.feature-card {
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 16px;
  padding: 18px 14px;
  text-align: center;
  cursor: pointer;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
}

.feature-card.disabled-feature {
  opacity: 0.6;
}

.feature-card.disabled-feature:hover {
  transform: none;
  box-shadow: none;
}

.feature-card:hover {
  transform: translateY(-10px);
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.2);
  border-color: rgba(102, 126, 234, 0.5);
}

.feature-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.1), transparent);
  transition: left 0.5s;
}

.feature-card:hover::before {
  left: 100%;
}

.card-icon {
  font-size: 36px;
  margin-bottom: 10px;
  display: block;
}

.card-title {
  color: white;
  font-size: 18px;
  font-weight: 600;
  margin: 0 0 15px 0;
}

.card-description {
  color: rgba(255, 255, 255, 0.8);
  font-size: 13px;
  line-height: 1.35;
  margin: 0 0 10px 0;
}

.card-features {
  display: flex;
  justify-content: center;
  gap: 8px;
  margin-bottom: 12px;
}

.feature-tag {
  background: rgba(102, 126, 234, 0.2);
  color: #667eea;
  padding: 5px 12px;
  border-radius: 20px;
  font-size: 11px;
  font-weight: 500;
  border: 1px solid rgba(102, 126, 234, 0.3);
}

.card-button {
  background: linear-gradient(45deg, #667eea, #764ba2);
  color: white;
  border: none;
  border-radius: 25px;
  padding: 8px 12px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  margin: 0 auto;
}

.card-button:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

.card-button:hover {
  transform: scale(1.05);
  box-shadow: 0 10px 20px rgba(102, 126, 234, 0.3);
}

.button-arrow {
  transition: transform 0.3s ease;
}

.card-button:hover .button-arrow {
  transform: translateX(5px);
}

.stats-section {
  display: flex;
  justify-content: center;
  gap: 60px;
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(10px);
  border-radius: 20px;
  padding: 40px;
  border: 1px solid rgba(255, 255, 255, 0.2);
}

.stat-item {
  text-align: center;
}

.stat-number {
  color: white;
  font-size: 28px;
  font-weight: 700;
  margin: 0 0 4px 0;
  background: linear-gradient(45deg, #00d4ff, #667eea);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.stat-label {
  color: rgba(255, 255, 255, 0.8);
  font-size: 14px;
  margin: 0;
}

.wechat-modal-mask {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 999;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
}

.wechat-modal {
  width: 100%;
  max-width: 360px;
  background: #fff;
  border-radius: 14px;
  overflow: hidden;
  box-shadow: 0 12px 30px rgba(0, 0, 0, 0.2);
}

.wechat-modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  border-bottom: 1px solid #eee;
}

.wechat-modal-header h3 {
  margin: 0;
  font-size: 16px;
  color: #222;
}

.wechat-close-button {
  border: none;
  background: #f4f6f9;
  color: #333;
  border-radius: 6px;
  padding: 6px 10px;
  cursor: pointer;
}

.wechat-modal-body {
  padding: 16px;
  text-align: center;
}

.wechat-qr-image {
  width: 240px;
  height: 240px;
  max-width: 100%;
  border-radius: 8px;
}

.wechat-link-text {
  margin-top: 10px;
  word-break: break-all;
  color: #555;
  font-size: 12px;
}

.background-animation {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
}

.tech-grid {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-image: 
    linear-gradient(rgba(255, 255, 255, 0.1) 1px, transparent 1px),
    linear-gradient(90deg, rgba(255, 255, 255, 0.1) 1px, transparent 1px);
  background-size: 50px 50px;
  animation: grid-move 20s linear infinite;
}

@keyframes grid-move {
  0% {
    transform: translate(0, 0);
  }
  100% {
    transform: translate(50px, 50px);
  }
}

.floating-element {
  position: absolute;
  border-radius: 50%;
  background: radial-gradient(circle, rgba(102, 126, 234, 0.1) 0%, transparent 70%);
  animation: float 8s infinite ease-in-out;
}

.element-1 {
  width: 100px;
  height: 100px;
  top: 20%;
  left: 10%;
  animation-delay: 0s;
}

.element-2 {
  width: 150px;
  height: 150px;
  top: 60%;
  right: 20%;
  animation-delay: 3s;
}

.element-3 {
  width: 80px;
  height: 80px;
  bottom: 30%;
  left: 70%;
  animation-delay: 6s;
}

@keyframes float {
  0%, 100% {
    transform: translateY(0px) rotate(0deg);
  }
  50% {
    transform: translateY(-30px) rotate(180deg);
  }
}

@media (max-width: 768px) {
  .header-content {
    flex-direction: column;
    gap: 12px;
  }
  .header-stats {
    width: 100%;
    justify-content: center;
  }
  
  .welcome-title {
    font-size: 24px;
  }
  
  .feature-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 10px;
  }
  
  .home-content {
    padding: 20px 10px 14px;
  }
}

@media (max-width: 480px) {
  .feature-card {
    padding: 14px 10px;
  }
  
  .card-icon {
    font-size: 28px;
  }
  
  .card-title {
    font-size: 16px;
  }
  
  .welcome-title {
    font-size: 20px;
  }

  .card-description {
    font-size: 12px;
  }

  .card-button {
    font-size: 13px;
    padding: 7px 10px;
  }
}
</style>
